import { AnyAction } from 'redux';
import { AppInfo } from './types';
const INIT_STATE:AppInfo = {
    loading: false,
    error : null
  };

  const appInfo = (state=INIT_STATE,action:AnyAction) =>{

     switch(action.type){
        case 'ENABLE_LOADING' :
            return{
                ...state,
                loading:true
            }
        case 'DISABLE_LOADING' :
            return{
                ...state,
                loading:false
            }
        case 'SHOW_ERROR' :
            return{
                ...state,
                error:action.payload.response?.data

            }
        case 'REMOVE_ERROR' :
            return {
                ...state,
                error: null
            }
        default :
        return state;
     }
  }

  export default appInfo;
  